export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const ADD_IMGS = 'ADD_IMGS'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const FETCH_DICT = 'FETCH_DICT'
export const FETCH_ADS = 'FETCH_ADS'
export const CHANGE_SEARCH = 'CHANGE_SEARCH'
export const FETCH_DICT_IDS = 'FETCH_DICT_IDS'
